import API from 'utils/api';
import { onError } from 'utils/handlers';

export const baseURL = 'contabilidad';

/**
 * GET Formas de Pago
  * @param {object} params
 */
export const getConceptosDeUnidadResponsable = async (params) => {
  try {
    const response = await API.get(`${baseURL}/conceptos-unidad-responsable`, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};
